module.exports = __webpack_public_path__ + "img/book_of_travels.2e512891.png";